export default class CursorTrail {
    constructor() {
        this.initListeners();
    }

    initListeners() {
        ['DOMContentLoaded', 'resize'].forEach((event) => {
            window.addEventListener(event, () => {
                if (window.outerWidth > 1009) {
                    this.initEffect();
                }
            });
        })
    }

    getRandom(min = 0, max = 1) {
        return Math.random() * (max - min) + min;
    }

    initEffect() {
        this.container = document.querySelector(".trail");

        addEventListener('mousemove', (e) => {
            // искуственно уменьшаем частоту появления частиц
            if (this.getRandom() > 0.15) {
                return
            }

            const particle = document.createElement('div');

            particle.classList.add('trail__particle');
            const top = (e.pageY + this.getRandom(-200, 200)) + 'px';
            const left = (e.pageX + this.getRandom(-200, 200)) + 'px';
            const size = this.getRandom(4, 100) + 'px';
            Object.assign(particle.style, {
                top: top,
                left: left,
                width: size,
                height: size
            });

            this.container.appendChild(particle);
            setTimeout(() => {
                this.container.removeChild(particle)
            }, 2000);
        });
    }
}





